import { FC } from "react";
import { IconZoomIn } from "@tabler/icons-react";

interface ZoomOverlayProps {
  position?: "top-right" | "top-left";
}

const ZoomOverlay: FC<ZoomOverlayProps> = ({ position = "top-right" }) => (
  <div
    style={{
      position: "absolute",
      top: "8px",
      ...(position === "top-right" ? { right: "8px" } : { left: "8px" }),
      backgroundColor: "rgba(0, 0, 0, 0.5)",
      borderRadius: "4px",
      padding: "4px",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    }}
  >
    <IconZoomIn size={20} color="white" />
  </div>
);

export default ZoomOverlay;
